import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { EPosition } from '../../../types/filters';
import { selectFiltersPosition } from '../../../selectors/filters';

const DISABLE_BY_SCROLL_TIMEOUT = 200;

export function useTooltipDisabled(): boolean {
  const filtersPosition = useSelector(selectFiltersPosition);
  const [isTooltipDisabledByPosition, setIsTooltipDisabledByPosition] = useState<boolean>(false);
  const [isTooltipDisabledByScroll, setIsTooltipDisabledByScroll] = useState(false);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    const handleScroll = () => {
      setIsTooltipDisabledByScroll(true);
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        clearTimeout(timeoutId);
        setIsTooltipDisabledByScroll(false);
      }, DISABLE_BY_SCROLL_TIMEOUT);
    };

    document.addEventListener('scroll', handleScroll);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    setIsTooltipDisabledByPosition(filtersPosition === EPosition.FixedHidden);
  }, [filtersPosition]);

  return isTooltipDisabledByPosition || isTooltipDisabledByScroll;
}
